import { render, staticRenderFns } from "./recordPayment.vue?vue&type=template&id=038572d3&scoped=true&"
import script from "./recordPayment.vue?vue&type=script&lang=js&"
export * from "./recordPayment.vue?vue&type=script&lang=js&"
import style0 from "./recordPayment.vue?vue&type=style&index=0&id=038572d3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038572d3",
  null
  
)

export default component.exports